module.exports = __webpack_public_path__ + "static/media/13.fa031278.png";